import { useCallback } from 'react'

import { F0ButtonToggle } from '@factorialco/f0-react'
import { Microphone, MicrophoneNegative } from '@factorialco/f0-react/icons/app'
import { usePersistentUserChoices } from '@livekit/components-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export const PrejoinMicrophoneButton = () => {
  const { userChoices, saveAudioInputEnabled } = usePersistentUserChoices()

  const handleMicToggle = useCallback(() => {
    saveAudioInputEnabled(!userChoices.audioEnabled)
  }, [userChoices.audioEnabled, saveAudioInputEnabled])

  return (
    <F0ButtonToggle
      icon={userChoices.audioEnabled ? Microphone : MicrophoneNegative}
      label={i18n.t('meetings.prejoin.control_bar.microphone.label')}
      onSelectedChange={() => {
        track(trackingEvents.meetings.ControlBarMuteButton, {
          isMuted: !userChoices.audioEnabled,
        })
        handleMicToggle()
      }}
      size="lg"
      selected={userChoices.audioEnabled}
    />
  )
}
